export default {
  props: {
    image: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    body: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      cardConfig: {
        cardType: '',
        background: {
          class: '',
        },
        main: {
          class: '',
        },
        article: {
          class: '',
        },
        header: {
          class: '',
        },
        body: {
          class: '',
        },
        footer: {
          class: '',
        },
      },
    }
  },
}
